import type { App as InstanceVueType } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import { aplusRoutes } from './routers';
import { adminRoutes } from './routers';
import { getPlatform } from '@/utils/url';

export const router = createRouter({
  history: createWebHashHistory(),
  routes: getPlatform() == 'user' ? aplusRoutes : adminRoutes,
  strict: true
});

export function setupRouter(app: InstanceVueType) {
  app.use(router);
}
